import React, {Component, Fragment} from 'react';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';


import Dropdown from 'Components/Dropdown';

import { SingleDatePicker, DateRangePicker } from 'react-dates';
import Input from 'Components/Input/index';

import { IS_RIL_RETAIL, PRODUCT_TYPE, MOVEMENT_TYPE, HIKAL, METRIC_SYSTEM, CARGO_PARTICULARS, UOM_CARGO_PACKING_TYPE, METRIC_SYSTEM_CONVERSION} from 'Constants/commonConstants';
import { getCompanyName, getUser } from 'Utils/storage';
import Checkbox from 'Components/Checkbox';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { ReactComponent as CopyIcon } from 'Icons/copy.svg';
import ConfirmationPopup from 'Components/ConfirmationPopup';

class VehicleDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        if(this.trip.cargoParticularList.length === 0) {
            this.trip.cargoParticularList.push(JSON.parse(JSON.stringify(CARGO_PARTICULARS)))
        }
        this.state = {
            activeView: 1,
            trip: this.trip
        }
        this.viewMode = props.viewMode;
    }
    setVehicleType = (vehicleType)=> {
        if(this.viewMode) {
            return;
        }
        // this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        // this.setState({
        //     trip: this.trip
        // });
        const { trip } = this.state;
        trip.vehicleType = vehicleType.value;
        trip.vehicleTypeName = vehicleType.name;
        this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        this.setState({ trip });

        this.props.onChange()
    }

    // setMovementType = (movementType) =>{
    //     if(this.viewMode) {
    //         return;
    //     }  
    //     const { trip } = this.state;
    //     //trip.movementType = movementType.value;
    //     trip.movementTypeName = movementType;
    //     this.trip.setMovementType(movementType);
    //     this.setState({trip});
    // }
    setVehicleBodyType = (vehicleBodyType)=> {
        if(this.viewMode) {
            return;
        }
        // this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        // this.setState({
        //     trip: this.trip
        // });

        const { trip } = this.state;
        trip.vehicleBodyType = vehicleBodyType.value;
        trip.vehicleBodyTypeName = vehicleBodyType.name;
        this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        this.setState({ trip });

        this.props.onChange()
    }
    setProductCategory = (productCategory) => {
        if (this.viewMode) {
            return;
        }
        this.trip.setProductCategoryType(productCategory.value, productCategory.name);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }
    onChangeRemarks = (e)=> {
        const { trip } = this.state;
        trip.remarks = e.target.value;
        this.trip.setRemarks(e.target.value);
        this.setState({ trip });
        this.props.onChange()
    }

    onAddNoOfContainers = (e) => {
        this.trip.setNoOfContainers(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    changeMetricSystem = (value, isConfirm) => {
        this.trip.setMetricSystem(value);
        if(isConfirm) {
            (this.trip.cargoParticularList || []).forEach(el => {
                const uomData = UOM_CARGO_PACKING_TYPE.filter(uom => this.trip.metricSystem === 1 ? uom.value !== 3 : uom.value === 3);
                el.uom = uomData[0];
            })
            this.trip.cargoParticularList = this.getVolumeWeight(this.trip.cargoParticularList);
            this.trip.setCargoParticulars(this.trip.cargoParticularList);
        }
        this.setState({
            trip: this.trip,
            isConfirmPopUp: false,
            confirmationData: ''
        });
        this.props.onChange()
    }

    removeParticulars = (index) => {
        const { trip } = this.state;
        trip.cargoParticularList.splice(index, 1);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange();
    }

    addParticulars = (value, isCopy) => {
        const { trip } = this.state;
        trip.cargoParticularList.push(JSON.parse(JSON.stringify(isCopy ? value : CARGO_PARTICULARS)));
        this.setState({ trip });
    }

    onChangeCargoParticulars = (e, index) => {
        const { name, value } = e.target;
        const { trip } = this.state;
        trip.cargoParticularList[index][name] = value;
        trip.cargoParticularList = this.getVolumeWeight(trip.cargoParticularList);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange();
    }

    getVolumeWeight = (data) => {
        const { rfq } = this.props;
        const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
        (data || []).forEach(el => {
            
            if(el.quantity && (el.uom || {}).value) {
                const cbmValue = (el.uom || {}).cbm || 1;
                const dimension = ( isLCL ? ((el.length / cbmValue) * (el.height / cbmValue) * (el.breadth/cbmValue)) : (el.length * el.height * el.breadth));
                el.volumeWeight = isLCL ? Number(dimension).toFixed(2) : Number(((dimension) / ((METRIC_SYSTEM_CONVERSION || []).find(msc => (msc.value === (el.uom || {}).value && msc.metricvalue === this.state.trip.metricSystem)) || {}).calValue) * el.quantity).toFixed(2);
                if(!isLCL && el.grossWeight && el.netWeight) {
                    el.chargableWeight = Number(Math.max(el.grossWeight, el.netWeight, el.volumeWeight)).toFixed(2);
                } else if(isLCL) {
                    el.chargableWeight = Number(dimension * el.quantity).toFixed(2);
                }
            }
        })
        return data;
    }

    onSelectCargoParticulars = (name, index, value) => {
        const { trip } = this.state;
        trip.cargoParticularList[index][name] = value;
        trip.cargoParticularList = this.getVolumeWeight(trip.cargoParticularList);
        this.trip.setCargoParticulars(trip.cargoParticularList);
        this.setState({
            trip: this.trip
        });
        this.props.onChange();
    }

    // handleOptionChange = (changeEvent) => {
    //     this.setState({
    //       selectedOption: changeEvent.target.value
    //     });
    //     this.setMovementType(changeEvent.target.value);
    //   }

    render() {
        const { 
            vehicleTypes,
            vehicleBodyTypes,
            productCategories,
            disablePlacementTime ,
            shouldShowVehicleTypes,
            submitted,
            rfqType,
            rfqServiceType,
            rfq
        } = this.props;
        const companyName = getCompanyName();
        const companyType = (companyName && companyName.includes(IS_RIL_RETAIL));
        const dropdownItems = ['id', 'name'];
        let totalChargableWeight = 0, totalNetWeight = 0, totalGrossWeight = 0, totalVolumeWeight = 0;
        return (
            <div className="pr">
                {(rfqType === 5 && HIKAL.includes(getUser().companyId)) && 
                <>
                {((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)  && <div className="mb-30">
                    <div className="header-medium-color fBold fs-16 mb-5 mt-20">
                        Cargo Particulars
                    </div>
                    <div className="flex flex-wrap fSemibold header-dark-color ml-5">
                        <div className="header-medium-color fBold fs-16 mb-5 mr-10 mt-5">
                            Metric System
                        </div>
                        {(METRIC_SYSTEM || []).map(el =>( <Checkbox label={(el.name || '').split('-')[0]} checked = {this.trip.metricSystem === el.value} className="mr-20 mb-5" 
                            onCheck={() => {
                            if(this.trip.metricSystem !== el.value &&  (this.trip.cargoParticularList || []).filter(cargo => cargo.volumeWeight && (cargo.uom || {}).value).length > 0) {
                                this.setState({ isConfirmPopUp: true, confirmationData: el });
                            } else {
                                this.changeMetricSystem(el);
                            }
                            }}
                        />))}
                    </div>
                    <div className="courier-table mt-5">
                        <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>Sl No.</th>
                                {/* <th>Metric System</th> */}
                                <th>Cargo Packing Type</th>
                                <th>No. of Units</th>
                                <th width="60">{'Length'}</th>
                                <th width="60">{'Breadth'}</th>
                                <th width="60">{'Height'}</th>
                                <th>UOM</th>
                                <th>Net Weight</th>
                                <th>Gross Weight</th>
                                <th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Unit Volume(CBM)' : 'Volume Weight'}</th>
                                <th>{((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? 'Chargeable Volume(CBM)' : `Chargeable Weight ${this.trip.metricSystem === 1 ? '(kgs)' : '(lb)'}`}</th>
                                <th width="100">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(this.trip.cargoParticularList || []).map((cParticular, index) =>{
                                totalChargableWeight += Number(cParticular.chargableWeight || 0);
                                totalGrossWeight += Number(cParticular.grossWeight || 0);
                                totalNetWeight += Number(cParticular.netWeight || 0);
                                totalVolumeWeight += Number(cParticular.volumeWeight || 0);
                            return(<tr>
                                <td style={{ 'borderBottom': '1px solid grey'}}>{index + 1}</td>
                                {/* <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Dropdown 
                                        onSelect={this.onSelectCargoParticulars.bind(this, 'metricSystem', index)}
                                        items={METRIC_SYSTEM} 
                                        selectedItem={METRIC_SYSTEM.find((metric)=> {
                                            return metric.value === (cParticular.metricSystem || {}).value
                                        })} 
                                        label="Select" 
                                        displayKey="name"
                                    />
                                </td> */}
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.pallet'}  
                                        value={cParticular.cargoPackingType} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'cargoPackingType'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.20'}  
                                        value={cParticular.quantity} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'quantity'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.10'}  
                                        value={cParticular.length} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'length'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.20'}  
                                        value={cParticular.breadth} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'breadth'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.30'}  
                                        value={cParticular.height} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'height'} 
                                    />
                                </td>
                                
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Dropdown 
                                        onSelect={this.onSelectCargoParticulars.bind(this, 'uom', index)}
                                        items={UOM_CARGO_PACKING_TYPE.filter(uom => this.trip.metricSystem === 1 ? uom.value !== 3 : uom.value === 3 )} 
                                        selectedItem={UOM_CARGO_PACKING_TYPE.find((cUOM)=> {
                                            return cUOM.value === (cParticular.uom || {}).value
                                        })} 
                                        label="Select" 
                                        displayKey="name"
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.1000'}  
                                        value={cParticular.netWeight} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'netWeight'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.2000'}  
                                        value={cParticular.grossWeight} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'grossWeight'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.1500'}  
                                        value={cParticular.volumeWeight} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'volumeWeight'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <Input  
                                        placeholder={'Eg.2000'}  
                                        value={cParticular.chargableWeight} 
                                        onChange={(e) => this.onChangeCargoParticulars(e, index)} 
                                        name={'chargableWeight'} 
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                    {this.trip.cargoParticularList.length- 1 === index && <PlusIcon onClick={this.addParticulars} className="wt-20 ht-20 bg-theme br-20 border-none curP br-50p mr-5" />}
                                    {this.trip.cargoParticularList.length !== 1 && <CloseIcon onClick={() => this.removeParticulars(index)} className="wt-25 ht-25 curP mr-5 pt-5" />}
                                    <CopyIcon onClick={() => this.addParticulars(cParticular, true)} className="wt-20 ht-20 curP mr-5" />
                                </td>
                            </tr>)})}
                            <tr>
                                <td colSpan="7" style={{ 'borderBottom': '1px solid grey'}}> Total </td>
                                <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalNetWeight}</span></td>
                                <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalGrossWeight}</span></td>
                                <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalVolumeWeight}</span></td>
                                <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalChargableWeight}</span></td>
                                <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}></td>
                            </tr>
                        </tbody>
                        </table>
                        {submitted && totalChargableWeight === 0 && <div className="error-color fs-14 fSemibold op-7 mt-10 ml-5">Please enter all the details</div>}
                    </div>
                </div>}
                </>}
                {shouldShowVehicleTypes && <div className="mb-30">
                    {/* <div className="header-medium-color fBold fs-16 mb-5">
                    Movement Type<sup className="danger-color ml-2 pr t-4">*</sup>
                    </div> */}
                    {/* <Dropdown 
                    onSelect={this.setVehicleType}
                    items={vehicleTypes} selectedItem={vehicleTypes.find((vehicleType)=> {
                        return vehicleType.value === this.trip.vehicleType
                    })} 
                    label="Select Movement type" 
                    displayKey="name"
                    searchEnabled={true}
                    searchPlaceholder={'Search Movement types'}
                    hasError ={submitted && !vehicleTypes.find((vehicleType)=> {
                        return vehicleType.value === this.trip.vehicleType
                    })} */}
                    {/* <Dropdown
                    onSelect ={this.setMovementType}
                                                items={[...MOVEMENT_TYPE]}
                                                selectedItem={MOVEMENT_TYPE.find(moveType => { return  moveType.value=== this.trip.movementType })}
                                                name="moveType"
            
                                                displayKey="name"
                                                className="flex-1 fs-14"
                                                label="Select Movement type"
                                                hasError ={submitted && !MOVEMENT_TYPE.find((moveType)=> {
                                                    return moveType.value === this.trip.movementType
                                                })}
                                          
                    /> */}
                   
                  {/* <input type="radio" value="doorTodoor" checked={this.state.selectedOption === 'doorTodoor'} onChange={this.handleOptionChange}/>
                  <label>Door To Door</label>
                  
                  <input type="radio" value="LegsWise" checked={this.state.selectedOption === 'LegsWise'} onChange={this.handleOptionChange}/>
                  <label>Legs Wise</label> */}
                </div>}
                {shouldShowVehicleTypes && ((rfqType === 5 && HIKAL.includes(getUser().companyId)) ? (rfq.rfqDetails || {}).serviceCategoryType !== 2 : true) && <div className="mb-30">
                    <div className="header-medium-color fBold fs-16 mb-5">
                    Select Container Type {rfqType!==2 && <sup className="danger-color ml-2 pr t-4">*</sup>}
                    </div>
                    <Dropdown 
                    onSelect={this.setVehicleType}
                    items={vehicleTypes} selectedItem={vehicleTypes.find((vehicleType)=> {
                        return vehicleType.value === this.trip.vehicleType
                    })} 
                    label="Select Container Type" 
                    displayKey="name"
                    searchEnabled={true}
                    searchPlaceholder={'Select Container Type'}
                    hasError ={submitted && !vehicleTypes.find((vehicleType)=> {
                        return vehicleType.value === this.trip.vehicleType
                    })}
                    />
                </div>}
                {((rfqType === 5 && HIKAL.includes(getUser().companyId)) ? (rfq.rfqDetails || {}).serviceCategoryType !== 2 : true) && shouldShowVehicleTypes && 
                <div className={'flex '}>
                    <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                            {`Select ${rfqServiceType === 4 || (rfqType === 5 && HIKAL.includes(getUser().companyId)) ? 'Container Body' : 'Vehicle Body'}  Type`} {rfqType!==2 && <sup className="danger-color ml-2 pr t-4">*</sup>}
                        </div>
                        <Dropdown 
                        items={vehicleBodyTypes} selectedItem={vehicleBodyTypes.find((vehicleBodyType)=> {
                            return vehicleBodyType.value === this.trip.vehicleBodyType
                        })}
                        onSelect={this.setVehicleBodyType}
                        label="Select Container Body Type" 
                        displayKey="name"
                        searchEnabled={true}
                        searchPlaceholder={'Search Container body types'}
                        hasError ={submitted && !vehicleBodyTypes.find((vehicleBodyType)=> {
                            return vehicleBodyType.value === this.trip.vehicleBodyType
                        })}
                        />
                    </div>
                    {rfqServiceType === 4 && rfqType!==2 && ((rfqType === 5 && HIKAL.includes(getUser().companyId)) ? (rfq.rfqDetails || {}).serviceCategoryType !== 2 : true) && <div className="mb-30 mt-4 ml-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                            Select Number Of Containers {/*<sup className="danger-color ml-2 pr t-4">*</sup>*/}
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.noOfContainers}
                            onChange={this.onAddNoOfContainers}
                            name="noOfContainers"
                            placeholder="No. Of Containers"
                        />
                    </div>}
                </div>
                }
                {disablePlacementTime && rfqServiceType === 4 && <div className="mb-30">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Select Placement Time
                    </div>
                    <div className="flex pb-20">
                        <SingleDatePicker
                            noBorder={true}
                            displayFormat={"DD MMM YYYY"}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel={true}
                            placeholder={"Placement Date"}
                            numberOfMonths={2}
                            date={Moment(this.trip.placementTime)} 
                            onDateChange={(placementDate) =>{
                                if(this.viewMode) {
                                    return;
                                }
                                const date = placementDate.format('YYYY-MM-DD') + ' ' + Moment(this.trip.placementTime).format('HH:mm')
                                this.trip.setPlacementTime(new Date(date).getTime());
                                this.setState({ trip: this.trip });
                                this.props.onChange()
                            }}
                            focused={this.state.focusedStart} 
                            onFocusChange={({ focused }) => this.setState({ focusedStart: focused })} 
                        />
                        <TimePicker
                            showSecond={false}
                            value={Moment(this.trip.placementTime)}
                            className="ht-40 wt-150 border-status-bar br-5"
                            onChange={(placementTime) =>{
                                if(this.viewMode) {
                                    return;
                                }
                                const date = Moment(this.trip.placementTime).format('YYYY-MM-DD') + ' ' + placementTime.format('HH:mm')
                                this.trip.setPlacementTime(new Date(date).getTime());
                                this.setState({ trip: this.trip });
                                this.props.onChange()
                            }}
                            format={'h:mm a'}
                            use12Hours
                            inputReadOnly
                        />
                    </div>
                </div>}
                {shouldShowVehicleTypes && companyType && <div className="mb-30">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Select Product Type<sup className="danger-color ml-2 pr t-4">*</sup>
                    </div>
                    <Dropdown 
                    items={productCategories.filter(function(o1){
                            return PRODUCT_TYPE.some(function(o2){ return o1.value === o2.value; });
                        }).map(function(o){
                            return dropdownItems.reduce(function(newo, name){
                                newo[name] = o[name];
                                return newo;
                            }, {});
                        })
                    } 
                    selectedItem={productCategories.find((category)=> {
                        return category.value === this.trip.productCategoryType
                    })}
                    onSelect={this.setProductCategory}
                    label="Select Product Type" 
                    displayKey="name"
                    searchEnabled={true}
                    searchPlaceholder={'Search Product Type'}
                    hasError ={submitted && !productCategories.find((category)=> {
                        return category.value === this.trip.productCategoryType
                    })}
                    />
                </div>}

                <div className="">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Remarks
                    </div>
                    <Input 
                        value={this.trip.remarks}
                        onChange={this.onChangeRemarks}
                        name="remarks"
                        placeholder="Please Enter Remarks"
                    />
                </div>
                {!shouldShowVehicleTypes && disablePlacementTime &&  <div className="pa center caption-color fSemibold fs-16 mt-20 ml-20">Nothing to enter</div>}
                {this.state.isConfirmPopUp &&
                    <ConfirmationPopup 
                    text={"Are you sure to change the metric system ?"}
                    onCancel={() => this.setState({ isConfirmPopUp: false, confirmationData: ''})}
                    onConfirm={() => this.changeMetricSystem(this.state.confirmationData, true)}
                    />
                }
            </div>
        )
    }
}

export default VehicleDetails;
